export default "__VITE_ASSET__CoOFl6SO__"